import React from 'react';
import classnames from 'classnames';

import CheckboxWithChild from './checkboxWithChild';
import UItem from '../item';
import { IProps } from './type';

// 表单 checkbox 有子组件的
function UCheckboxChild(props: IProps) {
  const {
    value,
    defaultValue,
    disabled,
    prefixCls = 'crm-checkbox-with-child',
    className,
    onChange,
    ...rest
  } = props;

  // 子项内容改变的时候进行数据更新
  const onValueChange = (e: any) => {
    if (onChange) {
      onChange({
        ...rest,
        value: e,
      });
    }
  };

  const cls = classnames(className, prefixCls);

  return (
    <UItem
      {...rest}
      className={cls}
      initialValue={value || defaultValue}
      validateTrigger="onChange"
    >
      <CheckboxWithChild
        {...rest}
        defaultValue={defaultValue}
        onChange={onValueChange}
      />
    </UItem>
  );
}

export default UCheckboxChild;
